import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip, Checkbox } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Icons from Ant Design
import DeptCreationForm from "../../Forms/DeptCreationForm/DeptCreationForm"
const DeptTable = ({
  history,
  loading,
  data,
  callReFetch,
  userData,
  dispatch,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedDept, setSelectedDept] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window dept
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const deptToEdit = data.find((dept) => dept._id === id);
    if (deptToEdit) {
      setSelectedDept(deptToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedDept(null);
  };

  const isAdmin = userData?.roles?.includes("admin");
  const renderActionButton = (id) => {
    if (!isAdmin) return null;
    return (<>
      {isMobileView ? (
        // Use icons on mobile view
        <>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => handleOpenEditModal(id)}
              dept="small"
              shape="circle"
              style={{ marginRight: 8 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(id)}
              dept="small"
              shape="circle"
              danger
            />
          </Tooltip>
        </>
      ) : (
        // Use buttons on desktop view
        <>
          <Button
            onClick={() => handleOpenEditModal(id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(id)} danger>
            Delete
          </Button>
        </>
      )}
    </>
  );
};

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Is Active?",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => (
        <Checkbox checked={isActive} disabled />
      )
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 400,
    },
  ];

  return (
    <>
      <div style={{width: "50vw"}}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={(pagination, filteredInfo, sorter) =>
                handleTableOnChange(pagination, filteredInfo, sorter)
              }
            />
          )}
        </Spin>
        <Modal
          title="Edit Dept"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <DeptCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            data={selectedDept}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

DeptTable.propTypes = {
};

export default DeptTable;
